import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _uniqueId from "lodash/uniqueId";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import { PressableContext, PressableControl, PressableControlLabel } from "../Pressable";
import { PressableThemeContext } from "../Pressable/PressableThemeProvider";
import SVGCompatBox from "../SVG/SVGCompatBox";
import FocusHandler from "../handler/FocusHandler";
import HoverHandler from "../handler/HoverHandler";

var CheckboxMark = function CheckboxMark(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.346 3.301a.929.929 0 0 1 1.37 0 1.076 1.076 0 0 1 0 1.456l-4.64 4.94a.929.929 0 0 1-1.37 0L3.284 7.123a1.076 1.076 0 0 1 0-1.456.929.929 0 0 1 1.37 0L6.39 7.513l3.955-4.212z"
  }));
};

CheckboxMark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this);
    _this.providedId = void 0;
    _this.providedId = _uniqueId('checkbox');
    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaDescribedBy = _this$props['aria-describedby'],
          ariaLabel = _this$props['aria-label'],
          ariaLabelledBy = _this$props['aria-labelledby'],
          checked = _this$props.checked,
          className = _this$props.className,
          description = _this$props.description,
          disabled = _this$props.disabled,
          id = _this$props.id,
          invalid = _this$props.invalid,
          label = _this$props.label,
          name = _this$props.name,
          onChange = _this$props.onChange,
          required = _this$props.required,
          wrap = _this$props.wrap,
          remaining = _objectWithoutProperties(_this$props, ["aria-describedby", "aria-label", "aria-labelledby", "checked", "className", "description", "disabled", "id", "invalid", "label", "name", "onChange", "required", "wrap"]);

      var classes = classNames('Checkbox', className, {
        'Is--disabled': disabled
      });
      var checkedState = {
        checked: checked || this.props.value === true
      };
      var isChecked = checkedState.checked;
      var idValue = id || this.providedId;
      return /*#__PURE__*/React.createElement(FocusHandler, null, function (focusProps, inputMethod) {
        var isFocused = inputMethod !== null;
        return /*#__PURE__*/React.createElement(HoverHandler, null, function (hoverProps, isHovering) {
          return /*#__PURE__*/React.createElement(PressableControlLabel, _extends({}, focusProps, hoverProps, {
            className: classes,
            id: idValue,
            disabled: disabled,
            hovered: isHovering,
            invalid: invalid,
            wrap: wrap,
            target: /*#__PURE__*/React.createElement(PressableControl, _extends({}, focusProps, hoverProps, {
              checked: isChecked,
              disabled: disabled,
              hovered: isHovering,
              focused: isFocused,
              radius: "all"
            }), /*#__PURE__*/React.createElement(PressableThemeContext.Consumer, null, function (themeContext) {
              return /*#__PURE__*/React.createElement(PressableContext.Consumer, null, function (context) {
                return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
                  flex: true,
                  style: {
                    color: themeContext.color.onPrimary
                  }
                }, /*#__PURE__*/React.createElement("input", _extends({}, remaining, checkedState, {
                  "aria-describedby": ariaDescribedBy,
                  "aria-invalid": invalid && 'true',
                  "aria-label": ariaLabel,
                  "aria-labelledby": ariaLabelledBy,
                  "aria-required": required && 'true',
                  className: classNames('Checkbox-source', context.pressableContextClasses),
                  disabled: disabled,
                  id: idValue,
                  name: name,
                  onChange: onChange,
                  type: "checkbox"
                })), /*#__PURE__*/React.createElement(SVGCompatBox, {
                  className: classNames('Checkbox-mark', {
                    'Checkbox-mark--visible': isChecked
                  }),
                  height: 14,
                  width: 14,
                  SvgElement: CheckboxMark,
                  color: "inherit"
                })));
              });
            })),
            label: label,
            description: description
          }));
        });
      });
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.defaultProps = {
  disabled: false,
  invalid: false,
  onChange: function onChange() {},
  wrap: true
};
export default Checkbox;